

























import { Component, Vue } from 'vue-property-decorator';
import PROJECTS from './defs/projects';
import { Project } from './defs/projects';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Footer,
  },
})
export default class App extends Vue {
  private projects: Project[] = PROJECTS;
}
